import React from 'react';

const PaymentCGV = () => {
  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4">
        <div className="bg-white rounded-xl p-8 border border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">{"Conditions Générales de Vente"}</h1>
          <p className="text-sm text-gray-400 mb-6">{"Dernière mise à jour : Décembre 2025"}</p>

          <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 1 – Objet"}</h2>
              <p>{"Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre FormaPro Digital (ci-après « le Vendeur ») et toute personne physique ou morale (ci-après « le Client ») souhaitant acquérir les produits numériques proposés sur le site."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 2 – Produits"}</h2>
              <p>{"Le Vendeur propose la vente de formations digitales sous forme de contenus numériques accessibles en ligne. Le produit principal est le « Book Formation E-Commerce » au prix de 59€ TTC. Le contenu exact de la formation est décrit sur la page produit du site."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 3 – Prix"}</h2>
              <p>{"Les prix sont indiqués en euros TTC. Le Vendeur se réserve le droit de modifier ses prix à tout moment, les produits étant facturés au prix en vigueur au moment de la validation de la commande."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 4 – Paiement"}</h2>
              <p>{"Le paiement s\u2019effectue en une seule fois par carte bancaire via la plateforme sécurisée Stripe. Aucun abonnement récurrent n\u2019est mis en place. Le paiement est exigible immédiatement à la commande."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 5 – Livraison"}</h2>
              <p>{"S\u2019agissant d\u2019un produit numérique, la livraison est effectuée immédiatement après confirmation du paiement par l\u2019attribution d\u2019un accès en ligne au contenu de la formation."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 6 – Droit de rétractation"}</h2>
              <p>{"Conformément à l\u2019article L221-28 du Code de la consommation, le droit de rétractation ne s\u2019applique pas aux contrats de fourniture de contenu numérique non fourni sur support matériel dont l\u2019exécution a commencé avec l\u2019accord du consommateur."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 7 – Propriété intellectuelle"}</h2>
              <p>{"L\u2019ensemble des contenus de la formation sont protégés par le droit de la propriété intellectuelle. L\u2019accès à la formation confère un droit d\u2019utilisation personnel et non cessible. Toute reproduction ou diffusion est strictement interdite."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 8 – Données personnelles"}</h2>
              <p>{"Les données personnelles collectées sont traitées conformément à notre Politique de confidentialité et au RGPD. Elles sont nécessaires au traitement de la commande et ne sont jamais transmises à des tiers non autorisés."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Article 9 – Litiges"}</h2>
              <p>{"Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. À défaut, les tribunaux français seront compétents."}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCGV;
